import {
  GET_DELIVERYMAN_COINS_PAYMENT_REPORT
} from '../../../Types'

const initialState = []

const DeliveryManCoinsPaymentReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DELIVERYMAN_COINS_PAYMENT_REPORT:
      return action.payload
    default:
      return state
  }
}
export default DeliveryManCoinsPaymentReportReducer